import {
  Injectable,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
} from '@angular/core';
import { MessageComponent } from '../components/message/message.component';

@Injectable({
  providedIn: 'root',
})
export class Message {
  constructor(
    private resolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector
  ) {}

  showMessage(message: string, status: string, customClass?: string) {
    let containerMessage = document.getElementById('containerMessage');
    if (!containerMessage) {
      containerMessage = document.createElement('div');
      containerMessage.id = 'containerMessage';
      if (document.getElementById('body')) {
        document.getElementById('body')?.appendChild(containerMessage)
      }
      containerMessage.style.position = 'absolute';
      containerMessage.style.top = '0px';
      containerMessage.style.right = '0px';
      containerMessage.style.transform = 'scale(var(--scaleResize))'
      containerMessage.style.transformOrigin = 'left top'
    }

    const messageC = this.resolver.resolveComponentFactory(MessageComponent);
    const componentRef = messageC.create(this.injector);
    componentRef.instance.message = message;
    componentRef.instance.status = status;
    if (customClass) {
      componentRef.instance.customClass = customClass;
    }
    this.applicationRef.attachView(componentRef.hostView);
    containerMessage.appendChild(componentRef.location.nativeElement);
    setTimeout(() => {
      containerMessage.removeChild(componentRef.location.nativeElement);
      componentRef.destroy();
    }, 5000);
  }
}
